export default "__VITE_ASSET__RIHHjWOF__"